/**
 * @desc 查询文案配置项
 */

import { RequestConfig, request } from 'umi';

function req(useless?: any, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.GeneralHttpResponse<defs.store.ConfigResponse>>(
    `/storeapi/api/v3/store/config`,
    {
      method: 'get',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<defs.store.ConfigResponse>;
export default req;
